import { Badge } from 'antd'
import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { t } from 'i18next'
import { get } from '../../Common/api'
import { Color } from '../../Common/Color'

const NO_ALERT = { critical: 0, warning: 0 }

// red badge with the boxes under a bandwidth alert limit, orange one with the boxes under a warning limit otherwise
export default function GepetoBadge () {
  const [alerts, setAlerts] = useState(NO_ALERT)

  useEffect(() => {
    get({ url: 'admin/gepetos/bandwidth_alerts', params: {}, onSuccess: setAlerts })
  }, [])

  const critical = alerts.critical > 0
  const count = critical ? alerts.critical : alerts.warning
  const style = { '--ant-color-text': Color.primary, backgroundColor: critical ? Color.primary : Color.dark_orange }

  return (
    <Badge count={count} style={style}>
      <Link to={'/admin/gepetos'} style={{ fontSize: '24px' }}>
        {t('Admin.Menu.gepetos')}
      </Link>
    </Badge>
  )
}
